(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('GeodataDeleteController',GeodataDeleteController);

    GeodataDeleteController.$inject = ['$uibModalInstance', 'entity', 'Geodata'];

    function GeodataDeleteController($uibModalInstance, entity, Geodata) {
        var vm = this;
        vm.geodata = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Geodata.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
